import { WistiaPlayer } from "@wistia/wistia-player"
import analyticsAction from "../analytics/analytics-action"

type PercentWatchedChangedEvent = Event & {
  detail: {
    percentWatched: number
    lastPercentWatched: number
  }
}

export default function analyticsWistia(player: WistiaPlayer) {
  player.addEventListener("api-ready", function () {
    const videoProperties = {
      "Video provider": "wistia",
      "Video ID": player.mediaId,
      "Video title": player.name,
      "Video length": player.duration,
    }

    let startedEventSent: boolean = false
    let watchedEventSent: boolean = false

    // We track the following events related to Wistia videos:
    //   Video played: when the video progresses beyond 3%.
    //   Video watched: when the percentage watched reaches 30% we consider it "watched".
    player.addEventListener("percent-watched-change", function (event) {
      const percentWatchedChangeEvent = event as PercentWatchedChangedEvent
      const { percentWatched, lastPercentWatched } =
        percentWatchedChangeEvent.detail
      // Determine if the video is a graphic only video
      // They are have autoplay, are muted, and have no playbar
      const { autoplay, muted, playBarControl } = player

      if (autoplay && muted && !playBarControl) return

      const currentStep =
        Math.round(((percentWatched + lastPercentWatched) / 2) * 100) / 100

      if (currentStep >= 0.03 && !startedEventSent) {
        startedEventSent = true
        analyticsAction("Video started", { ...videoProperties })
      }
      if (currentStep >= 0.3 && !watchedEventSent) {
        watchedEventSent = true
        analyticsAction("Video watched", { ...videoProperties })
      }
    })
  })
}
